import React from "react";
import DefaultLink from "../../../components/DefaultLink";
import { useModal } from "../../../contexts/ModalContext";

export default function SmallLaunch({data}) {
  const {openQueryModal} = useModal();
  return (
    <>
      <section className="small-launch-arera">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-9 text-center">
              <h3 className="heading">{data?.head}</h3>
              <p>{data?.desc}</p>
            </div>

            {data?.boxes?.map((item, index) => (
              <div className="col-md-6" key={index}>
                <div className="industry-serve-box">
                  <img src={item?.img} alt="industry" />
                  <span>{item?.title}</span>
                  <label>{item?.label}</label>
                  <p>{item?.desc}</p>
                  <DefaultLink to={item?.slug} onClick={openQueryModal} text={item?.btnText} />
                </div>
              </div>
            ))}

          </div>
        </div>
      </section>

    </>
  )
}